import React from 'react';
import { fmtScore, money, scoreTone } from './kpiFormat';

/* Обзор месяца: итоги в цифрах и по должностям. Клик по должности ведёт
   в её расчёт. */
const KpiOverview = ({ data, onOpenRole }) => {
  const t = data.totals;
  const byRole = data.roles.map(r => {
    const emps = data.employees.filter(e => e.role === r.key);
    const done = emps.filter(e => e.result.complete);
    return {
      ...r,
      count: emps.length,
      done: done.length,
      fund: emps.reduce((s, e) => s + e.result.bonus, 0),
      avg: done.length ? done.reduce((s, e) => s + e.result.score, 0) / done.length : null,
      best: [...done].sort((a, b) => b.result.score - a.result.score)[0],
    };
  });
  const filledPct = t.employees ? Math.round((t.complete / t.employees) * 100) : 0;

  return (
    <div className="kpi2-overview">
      <div className="kpi2-tiles">
        <div className="kpi2-tile kpi2-tile-accent">
          <span className="kpi2-tile-label">Фонд премий</span>
          <strong>{money(t.fund)}</strong>
          <span className="kpi2-tile-sub">{data.status === 'closed' ? 'утверждён' : 'предварительно, по внесённому факту'}</span>
        </div>
        <div className="kpi2-tile">
          <span className="kpi2-tile-label">Средний балл</span>
          <strong>{fmtScore(t.avg_score)}</strong>
          <span className="kpi2-tile-sub">из 10; премия — от {data.min_bonus_score}</span>
        </div>
        <div className="kpi2-tile">
          <span className="kpi2-tile-label">Получат премию</span>
          <strong>{t.with_bonus} из {t.employees}</strong>
          <span className="kpi2-tile-sub">сотрудников</span>
        </div>
        <div className="kpi2-tile">
          <span className="kpi2-tile-label">Заполнено</span>
          <strong>{filledPct}%</strong>
          <div className="ui-progress"><span style={{ width: `${filledPct}%` }} /></div>
        </div>
      </div>

      <div className="kpi2-role-grid">
        {byRole.map(r => (
          <button key={r.key} type="button" className={`kpi2-role-card ${r.count ? '' : 'is-empty'}`}
            onClick={() => onOpenRole(r.key)}>
            <div className="kpi2-role-card-head">
              <span className="kpi2-role-name">{r.name}</span>
              <span className={`kpi2-score-pill tone-${scoreTone(r.avg)}`}>{fmtScore(r.avg)}</span>
            </div>
            {r.count ? (
              <>
                <div className="kpi2-role-fund">{money(r.fund)}</div>
                <div className="kpi2-role-meta">
                  {r.count} чел. · посчитано {r.done} из {r.count}
                </div>
                <div className="ui-progress"><span style={{ width: `${(r.done / r.count) * 100}%` }} /></div>
                {r.issues.length > 0 && <div className="kpi2-role-warn">{r.issues[0]}</div>}
                {r.best && r.count > 1 && (
                  <div className="kpi2-role-meta">Лучший: {r.best.name} — {fmtScore(r.best.result.score)}</div>
                )}
              </>
            ) : (
              <div className="kpi2-role-meta">Сотрудники не добавлены</div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default KpiOverview;
